import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth, db } from "../services/Firebase";
import { doc, getDoc } from "firebase/firestore";
import { useAuth } from "../hooks/AuthContext";
import { formatDate, formatTime } from "../utils/FormatDateTime";
import { signOut } from "firebase/auth";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import logoImage from '../images/logo192.png'
import Aurora from "../utils/Aurora";


export default function SavedSummaryPage() {
    const { matchId } = useParams();
    const [matchData, setMatchData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showLogoutDialog, setShowLogoutDialog] = useState(false)

    const { authUser } = useAuth()
    const navigate = useNavigate()
    const { t } = useTranslation()

    useEffect(() => {
        if (authUser) {
            fetchMatch()
        }
    }, []);

    const fetchMatch = async () => {
        setLoading(true);
        try {
            const matchRef = doc(db, "users", authUser.uid, "summaries", matchId);
            const snapshot = await getDoc(matchRef);

            if (snapshot.exists()) {
                setMatchData({ id: snapshot.id, ...snapshot.data() })
                setLoading(false)
            } else {
                setMatchData(null);
                setLoading(false)
            }
        } catch (error) {
            console.error("Error loading match:", error);
            setMatchData(null);
            setLoading(false)
        }
    };


    const goToSearchPage = () => {
        navigate('/')
    }

    function onLogoutClick() {
        setShowLogoutDialog(true);
    }

    function cancelLogout() {
        setShowLogoutDialog(false);
    };

    function confirmLogout() {
        setShowLogoutDialog(false);
        signOut(auth)
    };


    return (
        <div className="profile-page">
            <div className="header-container">
                <div onClick={goToSearchPage} className='header-left'>
                    <img src={logoImage} alt="Logo" className="logo" />
                    <h3>Sigurica AI</h3>
                </div>
                <div className='header-right'>
                    <Button onClick={() => onLogoutClick()} className='button-logout'><i class="bi bi-box-arrow-in-left"></i>{t('logoutAction')}</Button>
                </div>
            </div>
            <div className="aurora-container">
                <div className="aurora-background">
                    <Aurora
                        colorStops={["#3A29FF", "#FF94B4", "#FF3232"]}
                        blend={0.5}
                        amplitude={1.0}
                        speed={1}
                    />
                </div>
                <div className="overlay-saved">
                    <div>
                        {loading ? (
                            <div className="spinner-wrapper">
                                <div className="spinner-border spinner-border-sm-custom" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : matchData ? (
                            <div className="summary-block">
                                <p className="summary-subtitle">{t('aiSummary')}</p>
                                <h2 className="mb-2">{matchData.homeTeamName} : {matchData.awayTeamName}</h2>
                                <p className="mb-1"> {matchData.leagueName}</p>
                                <p className="saved-summary-date-time mb-2">{formatDate(matchData.date)} • {formatTime(matchData.date)}h</p>
                                <p>{matchData.summary}</p>
                            </div>
                        ) : (
                            <p>No match data found.</p>
                        )}
                    </div>
                </div>
            </div>

            <Modal show={showLogoutDialog} onHide={cancelLogout} centered>
                <Modal.Header style={{ borderBottom: 'none' }} closeButton>
                    <Modal.Title>{t('logout')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className='text-center'>{t('confirmLogout')}</Modal.Body>
                <Modal.Footer className="d-flex justify-content-between" style={{ borderTop: 'none' }}>
                    <Button variant="secondary" onClick={cancelLogout} className="w-25 noButtonModal">{t('no')}</Button>
                    <Button variant="primary" onClick={confirmLogout} className="w-25 yesButtonModal">{t('yes')}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
